export default function parsePrice(price) 
{
    return Number(price.replace('€', '').replace(',', '.').trim())
}